import { SHOW_NOTIFICATIONS_STORE_KEY } from '../constants';
import type { State } from '../reducers/showNotificationReducers';

export const notificationsShowTypeSelector = (state: GlobalState) =>
    state[SHOW_NOTIFICATIONS_STORE_KEY] as State;
